import { useCallback } from 'react'
import { getCurrentDateAsString } from 'utils/date'

const STORAGE_KEY = 'studentsState'
const DATE_KEY = 'studentsStateDate'

export function checkAndClearOldData() {
  const storedDate = localStorage.getItem(DATE_KEY)
  const today = getCurrentDateAsString()

  if (storedDate !== today) {
    localStorage.removeItem(STORAGE_KEY)
    localStorage.setItem(DATE_KEY, today)
  }
}

function getState() {
  const raw = localStorage.getItem(STORAGE_KEY)
  return raw ? JSON.parse(raw) : {}
}

function saveState(data) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data))
}

export function getStoredDataByStudent(studentId) {
  const state = getState()
  return state[studentId] || null
}

export default function useClassroomStorage() {
  const updateStudentData = useCallback((studentId, data) => {
    const state = getState()
    if (!state[studentId]) state[studentId] = {}
    const oldData = state[studentId]
    state[studentId] = { ...oldData, ...data }
    saveState(state)
  }, [])

  const getStudentData = useCallback(studentId => {
    const state = getState()
    return state[studentId] || null
  }, [])

  const getStudentsData = useCallback(() => {
    const state = getState()
    return state
  }, [])

  const clearStudentData = useCallback(studentId => {
    const state = getState()
    const { [studentId]: _, ...newState } = state
    saveState(newState)
  }, [])

  const clearStudentsData = useCallback(() => {
    saveState({})
  }, [])

  return {
    updateStudentData,
    getStudentData,
    getStudentsData,
    clearStudentData,
    clearStudentsData
  }
}
